import { Route, Routes } from "react-router-dom"
import { UserScheduled } from "../pages/main"
import { UserScheduleDetail } from "../pages/detail"
import Detail from "../pages/preview"
import RecurrenceAlert from "../../calendar/pages/recurrenceAlert"
import Form from "../../actionPlans/pages/form"
import { ReportFolioDetailProvider } from "../../reportFolio/pages/dashboard/pages/detail/provider"
import { Main } from "../../reportFolio/pages/dashboard/pages/main"
import { UserScheduledProvider } from "../provider"
import { EditSerieUser } from "../pages/editSerie"

const UserScheduleRoutes = () => {
  return (
    <UserScheduledProvider>
      <Routes>
        {/* DASHBOARD */}
        <Route path="/" element={<UserScheduled />} />
        <Route path="/create" element={<UserScheduleDetail />} />
        <Route path="/:id" element={<UserScheduleDetail />} />
        <Route path="detail/:id" element={<Detail />} />
        <Route path="edit/:id" element={<EditSerieUser />} />
        <Route path="recurrence/:id" element={<RecurrenceAlert />} />
        <Route path="action-plan/:id" element={<Form />} />
        <Route path="report-folio/:id" element={<ReportFolioDetailProvider />} />
        <Route path="report-folio-list/" element={<Main />} />
      </Routes>
    </UserScheduledProvider>
  )
}

export { UserScheduleRoutes }
